import * as THREE from "three";

class Audio {
  static createAudio(name, info) {
    const audio = new THREE.Object3D();

    audio.position.set(0, 2, 0);
    audio.name = name;
    audio.userData.type = "audio";
    audio.userData.audioInfo = this.setAudioInfo(info);

    return audio;
  }

  static createAudioInObject() {
    const emptyInfo = {name: "", path: "", duration: 0};
    const audioInfo = this.setAudioInfo(emptyInfo);

    return audioInfo;
  }

  static setAudioInfo(info) {
    return {
      name: info.name,
      path: info.path,
      volume: 1,
      playbackRate: 1,
      autoplay: false,
      offset: {
        isActive: false,
        default: 0,
        value: 0,
      },
      duration: {
        isActive: false,
        default: info.duration,
        value: 0,
      },
      loop: {
        isActive: false,
        loopStart: {
          isActive: false,
          default: 0,
          value: 0,
        },
        loopEnd: {
          isActive: false,
          default: info.duration,
          value: 0,
        },
      },
      positional: {
        isActive: false,
        distanceModel: "linear",
        refDistance: 5,
        maxDistance: 20,
        rolloffFactor: 1,
        directionalCone: {
          isActive: false,
          coneInnerAngle: 150,
          coneOuterAngle: 240,
          coneOuterGain: 0,
        },
      },
    };
  }
}

export default Audio;
